import React, { useCallback, useMemo } from 'react';
import { AccountClient } from '@nile/graphql';
import { GET_ALL_TECHNICIAN_GROUPS } from '@nile/graphql/src/Query/techgroup';
import { GET_COMPANY_USERS } from '@nile/graphql/src/Query/automationrules';
import { RadioButton } from '@superops/ui-design-system';
import { AsyncPropSelector, getTranslatedText } from '@nile/components';
import {
  shareViewRadioOptions,
  shareTypeList
} from '@nile/mangifera/src/Constants/Tickets';

const ShareViewSelector = ({
  intl,
  isTechGroup,
  shareViewWith,
  onShareTypeChange,
  onTechniciansUpdate,
  technicians,
  errors
}) => {
  const generateOptions = useCallback(
    (field, data) => {
      const fieldName = isTechGroup
        ? 'getTechnicianGroups'
        : 'getCompanyUsersList';
      const sourceData = isTechGroup
        ? data?.[fieldName]
        : data?.[fieldName]?.userList;
      return (
        sourceData?.map((option) => ({
          ...option,
          value: isTechGroup ? option.groupId : option.userId,
          label: !isTechGroup
            ? `${option.name} (${option.email})`
            : option.name,
          email: !isTechGroup ? option.email : null
        })) || []
      );
    },
    [isTechGroup]
  );

  const dynamicQuery = useCallback(() => {
    const query = isTechGroup ? GET_ALL_TECHNICIAN_GROUPS : GET_COMPANY_USERS;
    return AccountClient.query({
      query,
      variables: {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      }
    });
  }, [isTechGroup]);

  const selectPlaceholder = useMemo(
    () =>
      getTranslatedText(
        intl,
        isTechGroup
          ? 'app.techGroupDropdown.placeholder'
          : 'common.choose.technician'
      ),
    [isTechGroup]
  );

  return (
    <>
      <div className="fx col g20 mt-20 mb-20">
        {shareViewRadioOptions.map((option) => {
          return (
            <RadioButton
              label={getTranslatedText(intl, option.labelKey)}
              checked={shareViewWith === option.id}
              id={option.id}
              name={option.id}
              onChange={() => onShareTypeChange(option.id)}
            />
          );
        })}
      </div>
      {(shareViewWith === shareTypeList.SPECIFIC_USER ||
        shareViewWith === shareTypeList.SPECIFIC_GROUP) && (
        <AsyncPropSelector
          autoFocus
          hideTitle
          isMulti
          isDynamicQuery
          defaultValue={technicians}
          updateSelection={onTechniciansUpdate}
          generateOptions={generateOptions}
          dynamicQuery={dynamicQuery}
          placeholder={selectPlaceholder}
          error={errors?.technicians}
          showErrorMessage
        />
      )}
    </>
  );
};
export default ShareViewSelector;
